import { ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { openInExternalBrowser } from '@/utils/inAppBrowser';
import { useI18n } from '@/contexts/I18nContext';
import { pickByLang } from '@/i18n';

const messages: Record<string, { title: string; desc: string; cta: string }> = {
  ko: {
    title: '인앱 브라우저에서는 로그인이 제한됩니다',
    desc: 'Chrome 또는 Safari에서 열어주세요.',
    cta: '외부 브라우저로 열기',
  },
  ja: {
    title: 'アプリ内ブラウザではログインできません',
    desc: 'ChromeまたはSafariで開いてください。',
    cta: '外部ブラウザで開く',
  },
  vi: {
    title: 'Không thể đăng nhập trong trình duyệt ứng dụng',
    desc: 'Vui lòng mở bằng Chrome hoặc Safari.',
    cta: 'Mở trình duyệt ngoài',
  },
  th: {
    title: 'ไม่สามารถเข้าสู่ระบบในเบราว์เซอร์ในแอป',
    desc: 'กรุณาเปิดใน Chrome หรือ Safari',
    cta: 'เปิดเบราว์เซอร์ภายนอก',
  },
  id: {
    title: 'Tidak bisa login di browser dalam aplikasi',
    desc: 'Silakan buka di Chrome atau Safari.',
    cta: 'Buka browser eksternal',
  },
  en: {
    title: 'Login is restricted in in-app browsers',
    desc: 'Please open this page in Chrome or Safari.',
    cta: 'Open in external browser',
  },
  ms: {
    title: 'Log masuk terhad dalam pelayar dalam aplikasi',
    desc: 'Sila buka menggunakan Chrome atau Safari.',
    cta: 'Buka pelayar luaran',
  },
  de: {
    title: 'Login ist im In-App-Browser eingeschränkt',
    desc: 'Bitte öffnen Sie die Seite in Chrome oder Safari.',
    cta: 'Im externen Browser öffnen',
  },
  es: {
    title: 'El inicio de sesión está limitado en navegadores internos',
    desc: 'Abre esta página en Chrome o Safari.',
    cta: 'Abrir en navegador externo',
  },
  fr: {
    title: 'La connexion est limitée dans le navigateur intégré',
    desc: 'Veuillez ouvrir cette page dans Chrome ou Safari.',
    cta: 'Ouvrir dans le navigateur externe',
  },
  ar: {
    title: 'تسجيل الدخول محدود داخل المتصفح المدمج',
    desc: 'يرجى فتح هذه الصفحة في Chrome أو Safari.',
    cta: 'افتح في متصفح خارجي',
  },
  'pt-BR': {
    title: 'O login e limitado no navegador interno',
    desc: 'Abra esta pagina no Chrome ou Safari.',
    cta: 'Abrir no navegador externo',
  },
  my: {
    title: 'Login is restricted in in-app browsers',
    desc: 'Please open this page in Chrome or Safari.',
    cta: 'Open in external browser',
  },
  'zh-TW': {
    title: '無法在應用內瀏覽器登入',
    desc: '請使用 Chrome 或 Safari 開啟。',
    cta: '用外部瀏覽器開啟',
  },
  'zh-CN': {
    title: '无法在应用内浏览器登录',
    desc: '请使用 Chrome 或 Safari 打开。',
    cta: '用外部浏览器打开',
  },
};

const InAppBrowserBanner = () => {
  const { lang } = useI18n();
  const m = pickByLang(messages, lang);

  return (
    <div className="rounded-xl border-2 border-accent bg-accent/10 p-4 text-center space-y-2">
      <p className="text-sm font-semibold text-foreground">{m.title}</p>
      <p className="text-xs text-muted-foreground">{m.desc}</p>
      <Button
        size="sm"
        className="gap-2 mt-1"
        onClick={() => openInExternalBrowser()}
      >
        <ExternalLink className="w-4 h-4" />
        {m.cta}
      </Button>
    </div>
  );
};

export default InAppBrowserBanner;
